import { LIFE_SCIENCES_DATE_FORMAT } from '@my-backoffice/app/shared/constants/date-format.constants';
import { Provider } from '@angular/core';
import { QIMA_DATE_CONFIG_TOKEN, QimaDateService } from '@qima/ngx-qima';

export { LIFE_SCIENCES_DATE_FORMAT } from '@my-backoffice/app/shared/constants/date-format.constants';

/** Route-scoped date config so life-sciences pickers emit `DD-MMM-YYYY` (e.g. `05-Jan-2026`). */
export const LIFE_SCIENCES_DATE_PROVIDERS: Provider[] = [
  {
    provide: QIMA_DATE_CONFIG_TOKEN,
    useValue: {
      format: LIFE_SCIENCES_DATE_FORMAT,
    },
  },
  QimaDateService,
];
